const config = {
  NAME: 'Beneficios',
  PATH: '/beneficios',
};

export default config;
